import { DownOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Dropdown, Flex, Tabs } from 'antd'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useTreatmentServiceGetHivAnamnesisCaseEndpoint,
  useTreatmentServiceGetSidaCaseEndpoint
} from 'src/api/queries'
import { Text } from 'src/components'
import { HivAnamnesisCaseTab } from 'src/features/hiv-anamnesis'
import { useStyles } from 'src/features/persons/styles'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { EpidemiologyCasesTab } from './EpidemiologyCasesTab'
import { SidaCaseTab } from './SidaCaseTab'

export const PersonEpidemiologyCasesPage = () => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const { id } = useParams()
  const navigate = useNavigate()

  const [activeTab, setActiveTab] = useState('epidemiology')

  const { data: sidaCase } = useTreatmentServiceGetSidaCaseEndpoint(
    { personId: String(id) },
    [id],
    { enabled: !!id, retry: false }
  )

  const { data: hivAnamnesisCase } =
    useTreatmentServiceGetHivAnamnesisCaseEndpoint(
      { personId: String(id) },
      [id],
      { enabled: !!id, retry: false }
    )

  const sidaExists = !!sidaCase?.id
  const hivAnamnesisExists = !!hivAnamnesisCase?.id

  const addMenuItems = [
    {
      key: 'epidemiology',
      label: t('epidemiology.add_epidemiology_case'),
      onClick: () => navigate(paths.patients.epidemiologyCases.add(String(id)))
    },
    ...(!sidaExists
      ? [
          {
            key: 'sida',
            label: t('sida_notification.add'),
            onClick: () =>
              navigate(paths.patients.sidaNotification.add(String(id)))
          }
        ]
      : []),
    ...(!hivAnamnesisExists
      ? [
          {
            key: 'hiv-anamnesis',
            label: t('hiv_anamnesis.add'),
            onClick: () =>
              navigate(paths.patients.hivAnamnesis.root(String(id)))
          }
        ]
      : [])
  ]

  const tabItems = [
    {
      key: 'epidemiology',
      label: t('persons.person_epidemiology-cases'),
      children: <EpidemiologyCasesTab />
    },
    {
      key: 'sida',
      label: t('sida_notification.title'),
      children: <SidaCaseTab />
    },
    {
      key: 'hiv-anamnesis',
      label: t('hiv_anamnesis.title'),
      children: <HivAnamnesisCaseTab />
    }
  ]

  return (
    <Flex vertical gap={16}>
      <Flex justify="space-between" gap={16} wrap="wrap">
        <Text className={styles.text}>
          {t('epidemiology.epidemiology_and_sida')}
        </Text>

        <Dropdown menu={{ items: addMenuItems }} trigger={['click']}>
          <Button type="primary" icon={<PlusOutlined />}>
            {t('common.add')} <DownOutlined />
          </Button>
        </Dropdown>
      </Flex>

      <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
    </Flex>
  )
}
